// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"84a8f99a","787":"280b3e36"}[chunkId] + ".chunk.js";
};